<template>
  <p>Hello from Vue island</p>
</template>
